import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { RootState } from "../../store/store";

import { setToggle } from "../../store/teamsStore";
import { loadTeamStateToggle } from '../../store/teamsStore';

import './Toggle.scss';

function Toggle() {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { toggleOptions, toggleCheck } = useSelector((state: RootState) => state.teams);

  const handleToggle = (value: string) => {
    dispatch(setToggle({ toggle: value }));
  };

  useEffect(() => {
    const savedState = loadTeamStateToggle();
    if (savedState !== null) {
      dispatch(setToggle({ toggle: savedState }));
    }
  }, [dispatch]);

  return (
    <div className="toggle_container">
      {/*<input type="checkbox" checked={toggleCheck} onChange={handleToggle}/>*/}
      <div className="toggle">
        {toggleOptions && toggleOptions.map((option, index) => (
          <button
            key={index}
            className={`toggle-text ${option.value} ${toggleCheck === option.value ? 'active' : ''}`}
            onClick={() => {
              if (toggleCheck !== option.value) {
                handleToggle(option.value);
              }
            }}
          >
            {t(option.label)}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Toggle;